import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ApiService, UserInfo } from 'app/services/api.service'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { StatsComponent } from '@components/stats/stats.component'
import { BarPercentComponent } from '@components/bar-percent/bar-percent.component'
import { StatData } from 'app/interfaces/stat.interface'
import { LoyaltyByCountry } from 'app/interfaces/loyalty-by-country.interface'
import { ButtonComponent } from '@components/button/button.component'
import { Router } from '@angular/router'
import { HomeLinksService } from '../../../services/home-links.service'

@Component({
    selector: 'app-banner-wecommerce',
    standalone: true,
    imports: [ButtonComponent, CommonModule, StatsComponent, BarPercentComponent, TranslateModule],
    templateUrl: './banner-wecommerce.component.html',
    styleUrls: ['./banner-wecommerce.component.scss'],
})
export class BannerWecommerceComponent implements OnInit {
    userInfo: UserInfo
    statsData: StatData[]
    nextLevel: LoyaltyByCountry | null = null

    constructor(
        private api: ApiService,
        private translate: TranslateService,
        private homeLinksService: HomeLinksService
    ) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            if (userInfo.loyaltyLevel && userInfo.country)
                this.api.getNextLoyaltyLevelRequirements(userInfo.loyaltyLevel, userInfo.country).subscribe((requirements) => {
                    //modeltypes:
                    // 01: brand presence
                    // 02: global presence
                    // 03 global presence + displays (obsolete)
                    // 04: global presence + cosentino displays (obsolete)
                    //por defecto miramos marca global y cogemos silestone ya que ambas marcas estaran informadas al mismo nivel en mercados con modelo global, esto afecta asi a USA y CA tambien
                    this.nextLevel = requirements
                    this.statsData = [
                        {
                            current: userInfo.ytdSales || 0,
                            total: requirements.ytdSales,
                            percent: requirements.ytdSales ? ((userInfo.ytdSales || 0) / requirements.ytdSales) * 100 : 0,
                            label: this.translate.instant('benefits_kb.salesYtd'),
                        },
                        {
                            current: userInfo.silestonePresence || 0,
                            // total: requirements.silestonePresence,
                            percent: requirements.silestonePresence ? ((userInfo.silestonePresence || 0) / requirements.silestonePresence) * 100 : 0,
                            label: this.translate.instant('benefits_kb.brand_presence'),
                        },
                    ]
                    //si es modelo 2 y la presencia diferencia entre marcas, añadimos dekton.
                    if (requirements.modelType == '02') {
                        this.statsData[1].label = this.translate.instant('benefits_kb.silestone_presence')
                        this.statsData.push({
                            current: userInfo.dektonPresence || 0,
                            // total: requirements.dektonPresence,
                            percent: requirements.dektonPresence ? ((userInfo.dektonPresence || 0) / requirements.dektonPresence) * 100 : 0,
                            label: this.translate.instant('benefits_kb.dekton_presence'),
                        })
                    }
                })
        })
    }

    private normalize(val?: string | null): string {
        return (val ?? '').toString().trim().toUpperCase()
    }

    get isPremiumSameLevel(): boolean {
        const a = this.normalize(this.userInfo?.loyaltyLevel)
        const b = this.normalize(this.nextLevel?.loyaltyStatus)
        if (!a || !b) return false
        return a === 'PREMIUM' && a === b
    }

    get titleKey(): string {
        return this.isPremiumSameLevel ? 'home.privatearea30_loyalty_widget_title' : 'benefits_kb.title'
    }

    get titleParams(): Record<string, any> {
        if (this.isPremiumSameLevel) return { loyalty: this.userInfo?.loyaltyLevel ?? 'PREMIUM' }
        return { currentLoyalty: this.userInfo?.loyaltyLevel, nextLoyalty: this.nextLevel?.loyaltyStatus }
    }

    goToKbBath() {
        this.homeLinksService.goToWecommerce()
    }
}